import { c as _c } from "react/compiler-runtime";
import { IcoChevronLeft16, IcoClose16 } from '@onefootprint/icons';
import { Dialog } from '@onefootprint/ui';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { BackgroundAgent } from '@/components/agent-chat/components/chat-widget/background-agents-context';
import InvestigationTranscript from '@/components/agent-chat/components/investigation-transcript';
type InvestigationChatDialogProps = {
  open: boolean;
  onClose: () => void;
  fpId: string;
  investigationId: string;
};

// A sub-agent opens in place of the run's transcript, with a back arrow, because the chat
// widget's agents sidebar can't show above this modal.
const InvestigationChatDialog = t0 => {
  const $ = _c(25);
  const {
    open,
    onClose,
    fpId,
    investigationId
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "header"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("investigations", t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      keyPrefix: "chat.backgroundAgents"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    t: tAgents
  } = useTranslation("copilot", t2);
  const [agent, setAgent] = useState(null);
  let t3;
  if ($[2] !== onClose) {
    t3 = () => {
      setAgent(null);
      onClose();
    };
    $[2] = onClose;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const handleClose = t3;
  let t4;
  if ($[4] !== agent?.label || $[5] !== t) {
    t4 = agent?.label ?? t(_temp);
    $[4] = agent?.label;
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== agent || $[8] !== tAgents) {
    t5 = agent ? {
      component: IcoChevronLeft16,
      ariaLabel: tAgents(_temp2),
      onClick: () => setAgent(null)
    } : undefined;
    $[7] = agent;
    $[8] = tAgents;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== agent || $[11] !== handleClose || $[12] !== tAgents) {
    t6 = agent ? {
      component: IcoClose16,
      ariaLabel: tAgents(_temp3),
      onClick: handleClose
    } : undefined;
    $[10] = agent;
    $[11] = handleClose;
    $[12] = tAgents;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  const t7 = agent?.id ?? null;
  let t8;
  if ($[14] !== fpId || $[15] !== investigationId || $[16] !== t7) {
    t8 = <InvestigationTranscript fpId={fpId} investigationId={investigationId} selectedAgentId={t7} onOpenAgent={setAgent} />;
    $[14] = fpId;
    $[15] = investigationId;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== handleClose || $[19] !== open || $[20] !== t4 || $[21] !== t5 || $[22] !== t6 || $[23] !== t8) {
    t9 = <Dialog title={t4} open={open} onClose={handleClose} size="large" noPadding={true} headerIcon={t5} headerAction={t6}>{t8}</Dialog>;
    $[18] = handleClose;
    $[19] = open;
    $[20] = t4;
    $[21] = t5;
    $[22] = t6;
    $[23] = t8;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  return t9;
};
export default InvestigationChatDialog;
function _temp($) {
  return $.agents.transcriptTitle;
}
function _temp2($_0) {
  return $_0.back;
}
function _temp3($_1) {
  return $_1.close;
}